var _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _g, _path111, _path112, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 194,
    viewBox: "0 0 311 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_259_1731",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -29,
    width: 310,
    height: 258
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.34837,
    y1: -28.7214,
    x2: 2.34837,
    y2: 228.337,
    stroke: "black",
    strokeWidth: 1.04213
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60648 -28.7214L4.60648 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3855 -28.7214L7.3855 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1645 -28.7214L10.1645 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9435 -28.7214L12.9435 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7225 -28.7214L15.7225 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5016 -28.7214L18.5016 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2806 -28.7214L21.2806 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0596 -28.7214L24.0596 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8386 -28.7214L26.8386 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6176 -28.7214L29.6176 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3966 -28.7214L32.3966 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1756 -28.7214L35.1756 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9547 -28.7214L37.9547 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7337 -28.7214L40.7337 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5127 -28.7214L43.5127 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2917 -28.7214L46.2917 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0707 -28.7214L49.0707 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8496 -28.7214L51.8496 228.338",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6288 -28.7214L54.6288 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4077 -28.7214L57.4077 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1868 -28.7214L60.1868 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9658 -28.7214L62.9658 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7448 -28.7214L65.7448 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5238 -28.7214L68.5238 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3028 -28.7214L71.3028 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0819 -28.7214L74.0819 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8609 -28.7214L76.8609 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6399 -28.7214L79.6399 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4189 -28.7214L82.4189 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1979 -28.7214L85.1979 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9769 -28.7214L87.9769 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7559 -28.7214L90.7559 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5349 -28.7214L93.5349 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M96.314 -28.7214L96.314 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99.093 -28.7214L99.093 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.872 -28.7214L101.872 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M104.651 -28.7214L104.651 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M107.43 -28.7214L107.43 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M110.209 -28.7214L110.209 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.988 -28.7214L112.988 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M115.767 -28.7214L115.767 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M118.546 -28.7214L118.546 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M121.325 -28.7214L121.325 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M124.104 -28.7214L124.104 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M126.883 -28.7214L126.883 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M129.662 -28.7214L129.662 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M132.441 -28.7214L132.441 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M135.22 -28.7214L135.22 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M137.999 -28.7214L137.999 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M140.778 -28.7214L140.778 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M143.557 -28.7214L143.557 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M146.336 -28.7214L146.336 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M149.115 -28.7214L149.115 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M151.894 -28.7214L151.894 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M154.673 -28.7214L154.673 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M157.452 -28.7214L157.452 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M160.231 -28.7214L160.231 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M163.01 -28.7214L163.01 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M165.789 -28.7214L165.789 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M168.568 -28.7214L168.568 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M171.347 -28.7214L171.347 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M174.126 -28.7214L174.126 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M176.906 -28.7214L176.906 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M179.685 -28.7214L179.685 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M182.464 -28.7214L182.464 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M185.243 -28.7214L185.243 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M188.022 -28.7214L188.022 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M190.801 -28.7214L190.801 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M193.58 -28.7214L193.58 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M196.359 -28.7214L196.359 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M199.138 -28.7214L199.138 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M201.917 -28.7214L201.917 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M204.696 -28.7214L204.696 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M207.475 -28.7214L207.475 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M210.254 -28.7214L210.254 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M213.033 -28.7214L213.033 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M215.812 -28.7214L215.812 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M218.591 -28.7214L218.591 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M221.37 -28.7214L221.37 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M224.149 -28.7214L224.149 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M226.928 -28.7214L226.928 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M229.707 -28.7214L229.707 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M232.486 -28.7214L232.486 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M235.265 -28.7214L235.265 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M238.044 -28.7214L238.044 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M240.823 -28.7214L240.823 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M243.602 -28.7214L243.602 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M246.381 -28.7214L246.381 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M249.16 -28.7214L249.16 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M251.939 -28.7214L251.939 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M254.718 -28.7214L254.718 228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M257.497 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M260.276 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M263.055 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M265.834 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M268.613 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M271.392 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M274.171 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M276.95 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M279.729 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M282.508 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M285.287 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M288.066 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M290.845 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M293.624 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M296.403 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M299.182 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M301.962 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M304.741 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M307.52 -28.7214V228.337",
    stroke: "black",
    strokeWidth: 1.04213
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_259_1731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.369 88.0559C69.3751 87.6768 4.54883 160.843 4.54883 160.843V192.058C4.54883 195.128 7.03724 197.616 10.1069 197.616H307.958C311.028 197.616 313.516 195.128 313.516 192.058V2C313.516 2 248.311 72.8919 242.624 74.7874C236.938 76.6829 183.484 72.8919 174.007 74.7874C164.529 76.6829 152.398 105.418 142.921 106.253C133.443 107.087 108.422 106.253 103.873 106.253C99.324 106.253 91.3629 88.435 80.369 88.0559Z",
    fill: "url(#paint0_linear_259_1731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8534 88.0559C67.8595 87.6768 3.0332 160.843 3.0332 160.843V192.058C3.0332 195.128 5.52162 197.616 8.59123 197.616H306.442C309.512 197.616 312 195.128 312 192.058V2C312 2 246.795 72.8919 241.109 74.7874C235.422 76.6829 181.969 72.8919 172.491 74.7874C163.014 76.6829 150.883 105.418 141.405 106.253C131.927 107.087 106.907 106.253 102.358 106.253C97.8084 106.253 89.8473 88.435 78.8534 88.0559Z",
    fill: "url(#paint1_linear_259_1731)"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0332 160.844C3.0332 160.844 67.8595 87.6775 78.8534 88.0566C89.8473 88.4357 97.8084 106.253 102.358 106.253C106.907 106.253 131.927 107.088 141.405 106.253C150.883 105.419 163.014 76.6836 172.491 74.7881C181.969 72.8926 235.422 76.6836 241.109 74.7881C246.795 72.8926 312 2.00073 312 2.00073",
    stroke: "url(#paint2_linear_259_1731)",
    strokeWidth: 2.08426,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M210.021 78.1046C212.272 78.1046 214.096 76.2802 214.096 74.0296C214.096 71.7791 212.272 69.9547 210.021 69.9547C207.771 69.9547 205.946 71.7791 205.946 74.0296C205.946 76.2802 207.771 78.1046 210.021 78.1046Z",
    fill: "white",
    stroke: "url(#paint3_linear_259_1731)",
    strokeWidth: 2.08426
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_1731",
    x1: 159.032,
    y1: 2,
    x2: 159.032,
    y2: 197.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_259_1731",
    x1: 157.517,
    y1: 2,
    x2: 157.517,
    y2: 197.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_259_1731",
    x1: 157.517,
    y1: 2.00073,
    x2: 157.517,
    y2: 160.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_259_1731",
    x1: 210.021,
    y1: 70.9968,
    x2: 210.021,
    y2: 160.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.bf92280490f1ca8626542c5192280f45.svg";
export { ForwardRef as ReactComponent };